<template lang="pug">
  .tip-container(v-if="show", @touchmove.prevent)
    .tip-dialog
      .close-icon(@click="closeModal")
      .main-title {{mainTitle}}
      .sub-title {{subTitle}}
      .know-btn(@click="closeModal") 我知道了
    .shadow
</template>
<script>
export default {
  props: {
    mainTitle: {
      type: String,
      default: '',
    },
    subTitle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    open() {
      this.show = true;
    },
    closeModal() {
      this.show = false;
      this.$emit('goRenewalPage');
    },
  },
};
</script>
<style lang="less" scoped>
.tip-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 330;

  .tip-dialog {
    position: relative;
    width: 3.2rem;
    background-color: #fff;
    border-radius: 12px;
    z-index: 332;
    text-align: center;
    font-family: PingFangSC-Medium, PingFang SC, sans-serif;

    .main-title {
      padding: 0.28rem 0.28rem 0;
      font-size: 0.18rem;
      font-weight: 500;
      color: #242729;
      line-height: 0.25rem;
    }

    .sub-title {
      margin-top: 0.16rem;
      padding: 0 0.24rem;
      font-size: 0.14rem;
      font-weight: 400;
      color: #5a6066;
      line-height: 0.2rem;
    }

    .know-btn {
      margin: 0.2rem 0.16rem 0.24rem;
      height: 0.4rem;
      background: linear-gradient(90deg, #fa8621 0%, #fa3a00 100%);
      border-radius: 0.08rem;
      color: #fff;
      font-size: 0.16rem;
      font-weight: 500;
      line-height: 0.4rem;
    }

    .close-icon {
      position: absolute;
      background-image: url(https://m.hellobike.com/resource/helloyun/15979/HP3T5BQrkn.png);
      background-repeat: no-repeat;
      background-size: 100% 100%;
      width: 0.16rem;
      height: 0.16rem;
      top: 0.12rem;
      right: 0.12rem;
    }
  }

  .shadow {
    position: fixed;
    z-index: 331;
    width: 100%;
    height: 100%;
    background: #000;
    opacity: 0.7;
  }
}
</style>
